import { Button, ModalContentWrapper } from 'ui';
import { useUpdateUserIdentityCenterProfile } from '@/modules/common/queries/profileSettings.ts';

interface WelcomeModalProps {
  open: boolean;
  onClose: () => void;
}

const FIRST_STEPS = [
  'Set up your departments',
  'Create your first form',
  'Assign tasks to your team',
];

export function WelcomeModal({ open, onClose }: WelcomeModalProps) {
  const updateProfile = useUpdateUserIdentityCenterProfile({ showToast: false });

  const handleClose = async () => {
    onClose();
    updateProfile.mutate({ has_seen_welcome_compliance: true } as any);
  };

  return (
    <ModalContentWrapper
      open={open}
      title="Welcome to Compliance"
      onClose={handleClose}
      variant="center"
      persistOnNavigate
      classes={{ dialogPanel: 'max-w-lg' }}
    >
      <div className="flex flex-col gap-6 px-6 pb-6 pt-2">
        <p className="text-sm text-gray-500">
          Here are a few first steps to help you get set up quickly.
        </p>

        <ol className="flex flex-col gap-3">
          {FIRST_STEPS.map((step, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-900 text-xs font-semibold text-white">
                {i + 1}
              </span>
              <span className="text-sm text-gray-700">{step}</span>
            </li>
          ))}
        </ol>

        <Button onClick={handleClose} loading={updateProfile.isPending}>
          Get started
        </Button>
      </div>
    </ModalContentWrapper>
  );
}
